<button [matMenuTriggerFor]="menu"
  class="promo-popover-trigger"
>
  <ng-content></ng-content>
</button>
<mat-menu #menu="matMenu"
  class="promo-popover-menu"
>
  <figure class="promo-popover-visual">
    <capra-icon
      width="180px"
      height="86px"
      icon="illo-studio-run-popover"
    ></capra-icon>
  </figure>
  <section class="promo-popover-text">
    <h3 class="promo-popover-header" *ngIf="isTrialExpired">
      Your trial has ended
    </h3>
    <h3 class="promo-popover-header" *ngIf="!isTrialExpired">
      Upgrade your account
    </h3>

    <p class="promo-popover-sub-trial" *ngIf="isTrialExpired">
      Talk to a Mode representative<br /> to upgrade today
    </p>
    <p class="promo-popover-sub" *ngIf="!isTrialExpired">
      to streamline collaboration
    </p>

    <ul class="promo-popover-list">
      <li *ngFor="let benefit of benefits"
        class="promo-popover-benefit"
      >
        <capra-icon icon="icon-check"></capra-icon>
        {{ benefit }}
      </li>
    </ul>

    <mode-calendly-popup-button
      *ngIf="isTrialExpired"
      [userEmail]="userEmail"
      [userDisplayName]="userDisplayName"
      class="trial-action-container">
      <button class="btn btn-lg btn-primary trial-btn secondary-trial-btn" (click)="trackClick('Report view','Run')">Book a call</button>
    </mode-calendly-popup-button>

    <a class="promo-popover-cta"
      *ngIf="!isTrialExpired"
      [modeLegacyRouterLink]="trialLink"
      [queryParams]="{ trk_element_id: startTrialElementId }"
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn More
    </a>
  </section>
</mat-menu>
